module.exports = __webpack_public_path__ + "static/media/mamas.0b3537e7.png";